module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_4.b19e9f61.jpg";